import { useEffect, useState } from "react";
import useAxiosPost from "../../hooks/useAxiosPost";
import { Col, Row } from "antd";
import { ButtonProps } from "../../helpers/constants";
import { FiPlusCircle } from "react-icons/fi";
import { useParams } from "react-router-dom";
import MeshBillButton from "../Items/Button/Index";
import CreateNewRadiusChildProbeModalComponent from "../Modals/CreateRadiusChildProbeModal";
import ViewRadiusChildProbesTable from "../Tables/ViewRadiusChildProbesTable";

// const MeshBillButton = lazy(() => import("../Items/Button/Index"));
// const ViewRadiusChildProbesTable = lazy(
//   () => import("../Tables/ViewRadiusChildProbesTable")
// );
// const CreateNewRadiusChildProbeModalComponent = lazy(
//   () => import("../Modals/CreateRadiusChildProbeModal")
// );

const ViewRadiusChildProbesComponent = () => {
  const { intPkMeshBillRadiusProbeID } = useParams();
  const [
    postApiData,
    apiResponse,
    apiError,
    apiLoading,
    apiMessage,
    apiErrorCount,
  ] = useAxiosPost<GetChildProbesByParentApiProp>(
    "radiusProbes/getChildProbesByRadiusProbe"
  );
  const [probes, setProbes] = useState<RadiusChildProbe[]>([]);
  const [showCreate, setShowCreate] = useState<boolean>(false);
  useEffect(() => {
    postApiData({
      intPkMeshBillRadiusProbeID: Number(intPkMeshBillRadiusProbeID),
    });
  }, []);
  useEffect(() => {
    if (apiResponse !== null) {
      const data: any = apiResponse.responseData;
      console.log({ data });
      setProbes(data || []);
    }
  }, [apiResponse]);
  const handleClose = (isReload: boolean) => {
    setShowCreate(false);
    if (isReload) {
      postApiData({
        intPkMeshBillRadiusProbeID: Number(intPkMeshBillRadiusProbeID),
      });
    }
  };

  return (
    <>
      {showCreate === true && (
        <CreateNewRadiusChildProbeModalComponent
          show={showCreate}
          handleClose={handleClose}
          intPkMeshBillRadiusProbeID={Number(intPkMeshBillRadiusProbeID)}
        />
      )}

      <Row className="full-width-row">
        <Col
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: "20px",
          }}
          span={24}
        >
          <MeshBillButton
            backgroundColor={ButtonProps.background.STANDARD}
            height={ButtonProps.height.STANDARD}
            width={ButtonProps.width.STANDARD}
            textColor={ButtonProps.color.STANDARD}
            onClick={() => {
              setShowCreate(true);
            }}
            text="Create Child Probe"
            icon={<FiPlusCircle />}
          />
        </Col>
        <Col span={24}>
          <ViewRadiusChildProbesTable isLoading={apiLoading} probes={probes} />
        </Col>
      </Row>
    </>
  );
};
export default ViewRadiusChildProbesComponent;
